import React, { useEffect, useRef, useState } from 'react'
import { getFileExtension } from 'services/helper/preSignHelper'
import { Box, Typography } from '@mui/material'
import { Document, Page, pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const AdxPdfImageViewer = ({ fileUrl, sxImg, sxPdf }) => {
  let fileType
  if (fileUrl) {
    fileType = getFileExtension(fileUrl)
  }

  // responsive width pdf viewer
  const [initialWidth, setInitialWidth] = useState(null)
  const pdfWrapper = useRef(null)

  const setPdfSize = () => {
    setTimeout(() => {
      if (pdfWrapper && pdfWrapper.current) {
        setInitialWidth(pdfWrapper.current.getBoundingClientRect().width)
      }
    }, 1)
  }

  useEffect(() => {
    window.addEventListener('load', setPdfSize())
    window.addEventListener('resize', setPdfSize())
    return () => {
      window.removeEventListener('resize', setPdfSize())
    }
  }, [fileUrl])

  switch (fileType) {
    case 'pdf':
      return (
        <Box
          ref={pdfWrapper}
          sx={{ width: 1, height: 1, aspectRatio: 1, overflow: 'hidden', ...sxPdf }}
        >
          <Document
            file={fileUrl}
            loading={<Typography color="gray-background.main">loading</Typography>}
          >
            <Page scale={1} pageNumber={1} width={initialWidth} />
          </Document>
        </Box>
      )

    default:
      return (
        <Box
          component="img"
          src={fileUrl}
          display="flex"
          justifyContent="center"
          height={1}
          width={1}
          sx={{
            objectFit: 'cover',
            objectPosition: '0% 0%',
            overflow: 'hidden',
            ...sxImg,
          }}

          // display={{ xs: "none", lg: "flex" }}
          // justifyContent="center"
          // alignItems="center"
          // width={1}
          // height={1}
        />
      )
  }
}

export default AdxPdfImageViewer
